export default "__VITE_ASSET__eRmRx7cF__"